import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";

import { RelatoriosRoutingModule } from "./regra-frete.routes";
import { ServicesModule } from "../services/services.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatIconModule,
  MatTooltipModule,
  MatDialogModule,
  MatChipsModule,
  MatOptionModule,
  MatSelectModule,
  MatDatepickerModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  MatSnackBarModule,
  MatProgressSpinnerModule,
} from "@angular/material";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { RegraFreteService } from "./services/regra-frete.service";
import { ListarRegraFreteComponent } from "./pages/listar/listar.component";
import { RegraFreteCriarComponent } from "./pages/criar/criar-regra-frete.component";
import { NgxMaskModule } from "ngx-mask";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CondicaoFaixaCepComponent } from "./pages/criar/condicoes/faixa-cep/faixa-cep.component";
import { CondicaoEstadosComponent } from "./pages/criar/condicoes/estados/estados.component";
import { CondicaoValorCarrinhoComponent } from "./pages/criar/condicoes/valor-carrinho/valor-carrinho.component";
import { CondicaoFaixaPesoComponent } from "./pages/criar/condicoes/faixa-peso/faixa-peso.component";
import { CondicaoFaixaPesoCubadoComponent } from "./pages/criar/condicoes/faixa-peso-cubado/faixa-peso-cubado.component";
import { ModalComponent } from "./components/modal/modal.component";
import { ItemRegraFreteComponent } from "./pages/listar/item/item.component";
import { RegraFreteEditarComponent } from "./pages/editar/editar-regra-frete.component";
import {
  CurrencyMaskConfig,
  CURRENCY_MASK_CONFIG,
} from "ng2-currency-mask/src/currency-mask.config";
import { ModalConfirmComponent } from "./components/confirm/modal.component";

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
};

@NgModule({
  declarations: [
    ListarRegraFreteComponent,
    RegraFreteCriarComponent,
    RegraFreteEditarComponent,
    CondicaoFaixaCepComponent,
    CondicaoEstadosComponent,
    CondicaoValorCarrinhoComponent,
    CondicaoFaixaPesoComponent,
    CondicaoFaixaPesoCubadoComponent,
    ModalComponent,
    ModalConfirmComponent,
    ItemRegraFreteComponent,
  ],
  imports: [
    CommonModule,
    RelatoriosRoutingModule,
    ServicesModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDialogModule,
    MatSnackBarModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatChipsModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatCheckboxModule,
    CurrencyMaskModule,
    DragDropModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [
    RegraFreteService,
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
  ],
  exports: [MatInputModule],
  entryComponents: [
    ListarRegraFreteComponent,
    RegraFreteCriarComponent,
    RegraFreteEditarComponent,
    CondicaoFaixaCepComponent,
    CondicaoEstadosComponent,
    CondicaoValorCarrinhoComponent,
    CondicaoFaixaPesoComponent,
    CondicaoFaixaPesoCubadoComponent,
    ModalComponent,
    ModalConfirmComponent,
    ItemRegraFreteComponent,
  ],
})
export class RegraFreteModule {}

try {
  angular
    .module("mandaeApp")
    .directive(
      "appRegraFreteListagem",
      downgradeComponent({ component: ListarRegraFreteComponent })
    )
    .directive(
      "appRegraFreteCriar",
      downgradeComponent({ component: RegraFreteCriarComponent })
    )
    .directive(
      "appRegraFreteEditar",
      downgradeComponent({ component: RegraFreteEditarComponent })
    );
  // .config([
  //   "$stateProvider",
  //   ($stateProvider: StateProvider) => {
  //     $stateProvider.state({
  //       name: "calculo-frete-criar",
  //       url: "/configuracoes-do-usuario/calculo-frete/criar",
  //       component: "appCalculoFreteCriar",
  //     });
  //   },
  // ]);
} catch (e) {}
